import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import M from 'materialize-css/dist/js/materialize';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import BackButton from '../../../../components/UI/BackButton';
import PickingService from '../../../../services/PickingService';
import ConfirmModal from '../../../../components/UI/ConfirmModal';
import * as actionsPicking from '../../../../actions/pickingAction';
import { ENUMS, PERMISSIONS, VISIONS } from '../../../../utils/constants';
import { formatData, hideKeyboardDevice, isNullOrEmpty, showMessageToastCustom, translate } from '../../../../utils/util';
import { checkPermission, getVision } from '../../../../services/auth';
import { onValueChange } from '../../../../utils/handleChangeHooks';
import useStateWithPromise from '../../../../utils/useEffectUpdate';
import { Collapsible, List } from '../../../../components/UI/ComponentsUI';

const ListItemMissionDetail = (props) => {
    const inputCIM = useRef();
    const messageModal = useRef();
    const [orders, setOrdes] = useState([]);
    const [refreshed, setRefreshed] = useState(false);
    const [modelMessage, setModelMessage] = useStateWithPromise({
        title: '',
        message: '',
        confirm: '',
        mission: '',
    });
    const [model, setModel] = useStateWithPromise({
        cim: '',
        totalItems: '',
    });

    const refreshComponent = () => {
        setRefreshed(!refreshed);
    }

    const onChange = (event) => {
        onValueChange(event, model, setModel);
    };

    useEffect(() => {
        document.addEventListener('message', msgHandler);
        M.updateTextFields();

        if (getVision() === VISIONS.Jeep) {
            document.addEventListener('message', msgHandler);
            M.updateTextFields();
            inputCIM.current.focus();
            hideKeyboardDevice();
        }
        totalItems();

        document.addEventListener('linePickingRefreshMission', refreshComponent);

        return () => {
            if (props.location.callback) {
                props.location.callback();
            }
            document.removeEventListener('message', msgHandler);
            document.removeEventListener('linePickingRefreshMission', refreshComponent);
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if ((getVision() !== VISIONS.Fiasa && getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD)) {
            inputCIM.current.focus();
            totalItems();
            if (refreshed && props.orders.filter((o) => o.orderId === props.mission.orderId).length === 0) {
                getNextMission(null, () => totalItems());
            }
            setRefreshed(false);
        }

        if (props.order?.items) {
            const pendingList = props.order.items.filter((m) =>
                (m.status === ENUMS.eOrderItemStatus.Waiting.value || m.status === ENUMS.eOrderItemStatus.InProgress.value)
                && m.orderItemId !== props.mission.orderItemId);
            setOrdes([...pendingList]);
        }
        // eslint-disable-next-line
    }, [props.mission, refreshed]);

    const handleFormKeyDown = (event) => {
        if (event.key === 'Enter' || event.keyCode === 13) {
            event.preventDefault();
            submit();
        }
    }

    const msgHandler = (e) => {
        const content = window.ReactNativeWebView;
        content.postMessage('');
        if (e.data.length === 10) {
            if (props.mission.cim !== e.data) {
                showMessageToastCustom(translate('general:warning'), translate('line-picking:CIM-incorret'), 3000, 'mdi mdi-alert-circle-outline red-text');
            } else {
                setModel({ ...model }).then(() => {
                    M.updateTextFields();
                });
            }
        }
    }

    const isValidForm = () => {
        let result = true;
        if (getVision() === VISIONS.Jeep) {
            if (isNullOrEmpty(model.cim)) {
                showMessageToastCustom(translate('general:warning'), translate('expedition:picking.cim-not-informed'), 3000, 'mdi mdi-alert-circle-outline red-text');
                result = false;
            } else if (model.cim.toString() !== props.mission.cim && model.cim !== props.mission.cimSupplier) {
                showMessageToastCustom(translate('general:warning'), translate('expedition:picking.cim-incorret'), 3000, 'mdi mdi-alert-circle-outline red-text');
                result = false;
            }
        }
        return result;
    }
    const callbackSubmit = (orderId) => {
        getNextMission(orderId, () => totalItems());

        if (getVision() !== VISIONS.Fiasa && getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD) {
            inputCIM.current.value = '';
            setModel({ ...model });
        }
    }

    const getNextMission = (orderItemId, callback) => {
        const pendingList = props.order.items.filter((m) =>
            (m.status === ENUMS.eOrderItemStatus.Waiting.value || m.status === ENUMS.eOrderItemStatus.InProgress.value)
            && (!isNullOrEmpty(orderItemId) ? m.orderItemId !== props.mission.orderItemId : m.orderItemId > 0));

        if (pendingList.length > 0) {
            props.startOrderItem(pendingList[0].orderId, pendingList[0].orderItemId, () => {
                props.setSelectedMission(pendingList[0]);
            });

            if (callback) {
                callback(pendingList[0].orderItemId);
            }
        } else {
            const pendingRepicking = props.order.items.filter((m) => m.status === ENUMS.eOrderItemStatus.WaitingRepicking.value);
            if (pendingRepicking.length > 0) {
                props.history.goBack();
            } else {
                props.history.go(-2);
            }
        }
    }

    const submit = () => {
        if (isValidForm() === true) {
            props.updateMissionStatus(props.mission.orderItemId, ENUMS.eOrderItemStatus.Finished.value);
            props.confirmPicking(props.mission);
            if (getVision() === VISIONS.Jeep) {
                getNextMission();
                inputCIM.current.value = undefined;
                model.cim = undefined;
                setModel(model)
            }
            else {
                props.history.go(-1);
            }
        }
    }

    const confirmRepicking = () => {
        showMessageModal(translate('validations:attention'), translate('expedition:picking.confirm-rePicking'),
            null, 'repicking');
    }

    const confirm = () => {
        if (modelMessage.confirm === 'nextMission') {
            if (modelMessage.mission.status === ENUMS.eOrderItemStatus.Waiting.value) {
                props.startOrderItem(modelMessage.mission.orderId, modelMessage.mission.orderItemId, () => {
                    props.setSelectedMission(modelMessage.mission);
                });
            } else {
                props.setSelectedMission(modelMessage.mission);
            }
        } else repicking();
    }

    const cancel = () => {
        if (modelMessage.confirm === 'nextMission') {
            props.history.goBack();
        }
    }

    const repicking = () => {
        props.rePicking(props.mission, () => {
            getNextMission(null, (orderItemId) => {
                props.history.replace({
                    pathname: `./order/${props.order.orderCode}/missions/${orderItemId}`
                });
            });
        });
    }

    const showMessageModal = (title, message, mission, confirm) => {
        const auxModel = modelMessage;
        auxModel.title = title;
        auxModel.message = message;
        auxModel.mission = mission;
        auxModel.confirm = confirm;
        setModelMessage({ ...auxModel }).then((n) => {
            if (confirm === 'nextMission') {
                return confirm();
            } else {
                messageModal.current.show();
            }
        });
    }

    const scanner = () => {
        if (navigator.userAgent === 'logisticspwa') {
            const content = window.ReactNativeWebView;
            content.postMessage('exibirTela');
        } else {
            showMessageToastCustom(translate('general:warning'), translate('validations:service-not-available'), 3000, 'mdi mdi-alert-circle-outline red-text');
        }
    }

    const goBackTask = (history) => {
        if (getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) {
            history.goBack(-1);
        }
        else {
            props.goBackTask(props.mission, () => {
                history.goBack();
            });
        }
    }

    const totalItems = () => {
        if (props.order.items?.length > 0) {
            if (props.order.items !== undefined && props.order.items.length === 0) {
                return '';
            }

            const total = props.order.items.filter((i) => i.status !== ENUMS.eOrderItemStatus.WaitingRepicking.value
                && i.status !== ENUMS.eOrderItemStatus.Repicking.value && i.status !== ENUMS.eOrderItemStatus.Canceled.value).length;

            const totalWaiting = props.order.items.filter((i) => i.status === ENUMS.eOrderItemStatus.Waiting.value).length;
            model.totalItems = `${(total - totalWaiting)}/${total}`;
            setModel({ ...model }).then(() => { M.updateTextFields(); });
        }
    };

    const renderButton = () => {
        let buttonCount = 1; // Bt Confirmar
        let showButtonRepicking = false;

        if (checkPermission(PERMISSIONS.Expedition.Picking.Repicking) || getVision() === VISIONS.Jeep) {
            showButtonRepicking = true;
            buttonCount += 1;
        }

        return {
            showButtonRepicking: showButtonRepicking,
            buttonCount: buttonCount
        }
    }

    return (
        <div>
            <BackButton {...props} onClick={goBackTask} />
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="title">
                        <i className="mdi mdi-dolly" />
                        {translate('expedition:picking.title')}
                    </div>
                    <div className="subtitle">
                        | <i className="material-icons">business_center</i>
                        {translate('expedition:picking.order')}
                    </div>
                    <div className="subtitle">
                        | <i className="material-icons">playlist_add_check</i>
                        {translate('expedition:picking.missions')}
                    </div>
                    <div className="subtitle">
                        | <i className="material-icons">filter_center_focus</i>
                        {translate('expedition:picking.cim')}
                    </div>
                </div>
            </div>
            <div className="container" style={{ marginTop: '35px', }}>
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                    <b>{model.totalItems}</b>
                </span>
                <div className="card">
                    <div className="card-content" style={{ padding: '7px' }}>
                        <form onKeyDown={handleFormKeyDown}>
                            <div className="row" style={{ marginBottom: '0' }}>

                                <div className="input-field no-padding col s6  mb-8" style={{ marginRight: '0' }} >
                                    <span className="field f-1p45r">{props.mission.cim}</span>
                                    <label className="active" htmlFor="cim">{translate('expedition:picking.cim')}</label>
                                </div>
                                <div className="input-field no-padding col s6  mb-8" style={{ marginRight: '0' }}>
                                    <span className="field f-1p45r">{props.mission.partnumber}</span>
                                    <label className="active" htmlFor="partnumber">{translate('expedition:picking.partnumber')}</label>
                                </div>

                                <div className="input-field no-padding col s12 mb-8">
                                    <span className="field f-1r">{props.mission.description}</span>
                                    <label className="active" htmlFor="description">{translate('expedition:picking.description')}</label>
                                </div>
                                <div className="input-field no-padding col s6 mb-8" style={{ marginRight: '0' }}>
                                    <span className="field f-1p45r">{props.mission.location}</span>
                                    <label className="active" htmlFor="location">{translate('expedition:picking.location')}</label>
                                </div>
                                <div className="input-field no-padding col s6 mb-8" style={{ marginRight: '0' }}>
                                    <span className="field f-1p45r">{props.mission.quantity}</span>
                                    <label className="active" htmlFor="quantity">{translate('expedition:picking.quantity')}</label>
                                </div>
                                <div className="input-field no-padding col s6 mb-8" style={{ marginRight: '0' }}>
                                    <span className="field f-1r">{props.mission.mdrType}</span>
                                    <label className="active" htmlFor="productId">{translate('expedition:picking.mdrType')}</label>
                                </div>
                                {!isNullOrEmpty(props.mission?.allocationDate) &&
                                    <div className="input-field no-padding col s6  mb-8" style={{ marginRight: '0' }}>
                                        <span className="field f-1r">{formatData(props.mission?.allocationDate)}</span>
                                        <label className="active" htmlFor="allocationDate">{translate('expedition:picking.allocationDate')}</label>
                                    </div>
                                }
                                {
                                    getVision() === VISIONS.Jeep && <div className="input-field no-padding col s12" style={{ marginTop: '5' }}>
                                        <input
                                            id="cim"
                                            name="cim"
                                            ref={inputCIM}
                                            type="number"
                                            onChange={onChange}
                                            onBlur={onChange}
                                            maxLength={9}
                                            defaultValue={model.cim}
                                        />
                                        <label className="required" htmlFor="cim">{translate('expedition:picking.cim')}</label>
                                        <i className="material-icons posfix" onClick={scanner.bind(this)}> camera_alt</i>
                                    </div>
                                }
                            </div>
                            <div className="card-action row center" style={{ padding: '1rem 0', marginBottom: '0' }}>
                                {
                                    renderButton().showButtonRepicking
                                    && <button
                                        type="button"
                                        onClick={() => confirmRepicking()}
                                        className={`col s${12 / renderButton().buttonCount}
                                        btn
                                        waves-effect
                                        waves-light
                                        btn-flat`}
                                    >
                                        {translate('expedition:picking.repicking')}
                                    </button>
                                }
                                <button
                                    type="button"
                                    className={`col s${12 / renderButton().buttonCount}
                                                btn
                                                btn-principal
                                                waves-effect
                                                waves-light`}
                                    onClick={submit}
                                >
                                    {translate('general:confirm')}
                                </button>
                            </div>
                        </form>

                    </div>

                </div>
                {
                    getVision() === VISIONS.Jeep && orders.length > 0 &&
                    <Collapsible
                        id="orderFilterGroup"
                        header={translate('expedition:picking.missions')}
                        body={
                            <List
                                data={orders.map((item) => (
                                    <div
                                        className="row"
                                        style={{ backgroundColor: 'white', color: 'black', display: 'block', marginBottom: '0px', marginLeft: '0px' }}
                                        onClick={() => {
                                            callbackSubmit(item.orderItemId);
                                        }}
                                    >
                                        <div className="col s12" style={{ padding: '0px', fontWeight: 'bold' }}>
                                            {`${translate('expedition:picking.partnumber')}: ${item?.partnumber || ''}`}
                                        </div>
                                        <div className="truncate col s12" style={{ padding: '0px' }}>
                                            {`Descrição: ${item?.description}`}
                                        </div>
                                        <div className="col s12" style={{ padding: '0px' }}>
                                            {`${translate('line-picking:linepicking.location')}: ${item?.location || ''}`}
                                        </div>
                                        <div className="col s6" style={{ padding: '0px' }}>
                                            {`CIM: ${item?.cim || ''}`}
                                        </div>
                                        <div className="col s5" style={{ padding: '0px' }}>
                                            {`Qtd: ${item?.quantity || ''}`}
                                        </div>
                                    </div>
                                ))}
                            />
                        }
                    />
                }
            </div>
            <ConfirmModal
                ref={messageModal}
                id="confirmRepicking"
                data={{ title: modelMessage.title, message: modelMessage.message }}
                onConfirm={confirm}
                onCancel={cancel}
                btnCancel={translate('general:cancel')}
                btnConfirm={translate('general:confirm')}
            />
        </div >
    );
}

const mapStateToProps = (state) => {
    return {
        mission: state.pickingReducer.mission,
        order: state.pickingReducer.order,
        orders: state.pickingReducer.orders
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        confirmPicking: (orderItem) => {
            dispatch(PickingService.confirmPicking(orderItem));
        },
        rePicking: (orderItem, callback) => {
            dispatch(PickingService.rePicking(orderItem, callback));
        },
        setSelectedMission: (mission) => {
            dispatch(actionsPicking.selectMission(mission));
        },
        updateMissionStatus: (orderItemId, status) => {
            dispatch(actionsPicking.updateMissionStatus(orderItemId, status));
        },
        startOrderItem: (orderId, orderItemId, callback) => {
            dispatch(PickingService.startOrderItem(orderId, orderItemId, callback));
        },
        goBackTask: (mission, callback) => {
            dispatch(PickingService.unblockMission(mission, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ListItemMissionDetail)));
